import { api } from "@/lib/api-client"

import { LogoutResponse } from "../types/api"

export const logout = (): Promise<LogoutResponse> => {
  return api.post("/auth/logout")
}
